export const dateMasks: Record<string, string> = {
    fr: '__/__/____',
    en: '__/__/____',
    'en-US': '__/__/____',
    ru: '__.__.____',
    de: '__.__.____',
    cs: '__.__.____',
}

export default dateMasks
